"use strict";

// Range utility function
export default function range(start, end) {
  var list = [];
  for (let i = start; i < end; i++) {
    list.push(i);
  }
  return list;
};



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/utils/range.js
 **/